import {getField, updateField} from 'vuex-map-fields';

const getters = {
    getField,
};

const state = {
    card: null,
    stripe: null,
    elements: null,
    token: null
};

const mutations = {
    updateField,
    setCard(state, card) {
        state.card = card;
    },
    setStripe(state, stripe) {
        state.stripe = stripe;
    },
    setElements(state, el) {
        state.elements = el;
    }
};

const actions = {
    createCardToken({commit, state}) {
        return state.stripe.createToken(state.card);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};